export default {
  mediaSaturation: 'Saturação de Mídia (%)'
}
